


















import {
  computed,
  createComponent,
  inject
  // SetupContext,
} from "@vue/composition-api";
import ProvisionalKey from "@/components/memberregistration-provisional-key";
import RegistrationKey from "@/components/memberregistration-registration-key";
import logoSvg from "@/assets/svg/logo.svg";
export default createComponent({
  setup() {
    const registration = inject(RegistrationKey);
    if (!registration) {
      throw new Error(`${RegistrationKey} is not provided`);
    }
    const provisional = inject(ProvisionalKey);
    if (!provisional) {
      throw new Error(`${ProvisionalKey} is not provided`);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    const loading = computed(() => registration.loading || provisional.loading);

    return { loading };
  },
  components: {
    logoSvg
  }
});
